import React from 'react';
import ProjectDetail from '../components/portfolio/ProjectDetailCarousel';
import Header from '../components/Header';

const ProjectDetailPage = () => {
  return (
    <>
      <Header />
      <ProjectDetail />
    </>
  );
};

export default ProjectDetailPage;